export const getUnmatchedKeys = (searchState, formikValues,omit=[]) => {
    const isEqual = (value1, value2) => {
        if (Array.isArray(value1) && Array.isArray(value2)) {
            return JSON.stringify(value1) === JSON.stringify(value2);
        }
        return value1 === value2;
    };

    const unmatchedKeys = [];

    for (const key in searchState) {
        if(omit.some(i=>i==key))
        {
            continue;
        }
        if (key === 'date_range') {
            if (!isEqual(searchState[key], formikValues.created_date)) {
                unmatchedKeys.push(key);
            }
        }
        else if (!isEqual(searchState[key], formikValues[key])) {
            unmatchedKeys.push(key);
        }
    }

    return unmatchedKeys;
};